import { IDXOptional } from 'idx';
import { Scalars } from 'types/graphql';

export type { Maybe } from 'types/graphql';
// for when we could get Maybe<T> or undefined
export { IDXOptional as Optional };

// this our schema's "Error" type, different from the graphql package's "Error"
// which is returned from QueryResult
export type { Error as PayloadError } from 'types/graphql';

// Derive a type from another type by omitting one of its keys
// https://stackoverflow.com/a/50918777/56690
export type Omit<T, K> = Pick<T, Exclude<keyof T, K>>;

// return all possible value types of indexable type
export type ValueOf<T> = T[keyof T];

export type ID = Scalars['ID']['output'];
export type Email = Scalars['Email']['output'];

export type Time = Scalars['Time']['output'];

// Narrow a `node(id: ...) { ... on Typename { ... } }` union/interface result
// down to the `Typename` variant, or undefined if it's some other type.
export function matchType<
  T extends { __typename?: string },
  K extends T['__typename']
>(
  node: T | null | undefined,
  typename: K
): Extract<T, { __typename: K }> | undefined {
  if (node?.__typename !== typename) {
    return undefined;
  }
  return node as Extract<T, { __typename: K }>;
}

// Drop null/undefined entries from a GraphQL connection's `nodes` list
// (Relay-style connections type list items as nullable).
export function compact<T>(
  nodes: readonly (T | null | undefined)[] | null | undefined
): T[] {
  return (nodes ?? []).filter((node): node is T => node != null);
}

// matchType + compact in one step, for the common case of narrowing a union
// result then immediately reading a compacted `nodes` list off it.
export function matchNodes<
  T extends { __typename?: string },
  K extends T['__typename'],
  R
>(
  node: T | null | undefined,
  typename: K,
  nodes: (
    matched: Extract<T, { __typename: K }>
  ) => readonly (R | null | undefined)[] | null | undefined
): R[] {
  const matched = matchType(node, typename);
  if (!matched) {
    return [];
  }
  return compact(nodes(matched));
}
